export const SET_VALOR_DEVOLUCAO = 'devolucao/SET_VALOR_DEVOLUCAO';
export const ENVIAR_DEVOLUCAO_REQUEST = 'devolucao/ENVIAR_DEVOLUCAO_REQUEST';
export const ENVIAR_DEVOLUCAO_SUCCESS = 'devolucao/ENVIAR_DEVOLUCAO_SUCCESS';
export const ENVIAR_DEVOLUCAO_ERROR = 'devolucao/ENVIAR_DEVOLUCAO_ERROR';
export const SET_TIPO_DEVOLUCAO = 'devolucao/SET_TIPO_DEVOLUCAO';
